import React from "react";
import { Link } from "react-router-dom";

const FooterOneAr = () => {
  return (
    <>
      <div
        className="footer__area section-padding"
        style={{ bottom: "0", width: "100%" }}
      >
        <div className="container" dir="rtl">
          <div className="row align-items-center">
            <div className="col-xl-12 col-lg-12">
              <div className="footer__area-widget">
                <div className="footer__area-widget-about lg-t-center">
                  <div className="row">
                    <div
                      className="col-6"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div className="footer__area-widget-about-logo">
                        <Link to="/">
                          <img src="assets/img/logo-2.png" alt="" />
                        </Link>
                      </div>
                    </div>
                    <div className="col-6" style={{ margin: "auto" }}>
                      {/* <div
                        className="footer__area-widget-about-social"
                        style={{ textAlign: "center" }}
                      >
                        <ul>
                          <li>
                            <a
                              href="https://www.facebook.com/profile.php?id=61554672084270"
                              target="_blank"
                            >
                              <i className="fab fa-facebook-f"></i>
                            </a>{" "}
                          </li> 
                        <li>
                        <Link to="">
                          <i className="fab fa-twitter"></i>
                        </Link>{" "}
                      </li>
                        <li>
                        <Link to="">
                          <i className="fab fa-behance"></i>
                        </Link>{" "}
                      </li>
                        <li>
                            <a
                              href="https://www.instagram.com/edu_club__?igshid=NzZlODBkYWE4Ng%3D%3D"
                              target="_blank"
                            >
                              <i className="fab fa-instagram"></i>
                            </a>{" "}
                          </li>
                         <li>
                        <Link to="">
                          <i className="fal fa-basketball-ball"></i>
                        </Link>{" "}
                      </li>
                         <li>
                        <Link to="">
                          <i className="fab fa-pinterest-p"></i>
                        </Link>{" "}
                      </li>
                         <li>
                        <Link to="">
                          <i className="fab fa-instagram"></i>
                        </Link>{" "}
                      </li>
                        </ul>
                      </div> */}
                      <div
                        className="footer__area-widget-about-menu"
                        style={{ textAlign: "center" }}
                      >
                        <ul
                          style={{
                            display: "flex",
                            justifyContent: "space-evenly",
                          }}
                        >
                          <li>
                            <Link to="/Ar">الشروط والأحكام</Link>
                          </li>
                          <li>
                            <Link to="/privacy-policyAr">سياسة الخصوصية</Link>
                          </li>
                          <li>
                            <Link to="/contactAr">تواصل معنا</Link>
                          </li>
                          {/* <li>
                        <Link to="/news">News</Link>
                      </li>
                          <li>
                            <Link to="/about">About</Link>
                          </li> */}
                          {/* <li>
                            <Link to="/contact">Contact</Link>
                          </li> */}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="copyright__area copyright__area-one">
              <div className="container">
                <div className="row align-items-center copyright__area-border">
                  <div className="col-xl-12" style={{ paddingTop: "1rem" }}>
                    <div className="copyright__area-left copyright__area-one-left">
                      <p>
                        Copyright © 2024 by{" "}
                        <a
                          href="https://www.neoneg.com/"
                          target="_blank"
                          style={{ color: "white" }}
                        >
                          {" "}
                          NEON
                        </a>{" "}
                        <a
                          href="https://wa.me/+2001113588988"
                          target="_blank"
                          style={{ color: "white" }}
                        >
                          <i className="fab fa-whatsapp"></i>
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="col-xl-5 col-lg-5">
              <div className="footer__area-widget">
                <div className="footer__area-widget-subscribe one">
                  <h4>Subscribe</h4>
                  <form action="#">
                    <input type="email" placeholder="Email Address" required />
                    <button type="submit">
                      <i className="fal fa-hand-pointer"></i>
                    </button>
                  </form>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default FooterOneAr;
